export default {
  eyebrow: 'Portal partnera',
  title: 'Opłaty za przetwarzanie',
  description:
    'Opłaty Stripe od każdej płatności online pokrywasz Ty. Ustawiona tu opłata za przetwarzanie jest naliczana Twoim restauracjom na ich pokrycie, chyba że restauracja ma własną stawkę.',
  card_title: 'Domyślna opłata za przetwarzanie',
  hint: 'Procent w %, plus opcjonalna kwota stała i minimalna za płatność. „Dowolna metoda płatności” obowiązuje, gdy nie ma stawki dla konkretnej metody. Zmiana dotyczy płatności dokonanych po jej zapisaniu.',
  hint_single:
    'Opłata za przetwarzanie dotyczy każdej internetowej metody płatności, która nie ma własnej stawki. Zmiana obowiązuje dla płatności dokonanych po jej zapisaniu.',
  hidden_rates:
    'Niektóre metody płatności mają też własną stawkę, ustawioną przez pomoc techniczną Twojej platformy. Obowiązuje ona zamiast tej stawki.',
  empty: {
    title: 'Nie ustawiono domyślnej opłaty za przetwarzanie',
    description:
      'Dopóki jej nie ustawisz lub nie potwierdzisz, że nie pobierasz od swoich restauracji prowizji za przetwarzanie, Twoje restauracje korzystające ze Stripe nie mogą zostać uruchomione, a działające nie przyjmują płatności online (gotówka nadal działa).',
  },
  consent: {
    give: 'Sami pokrywamy prowizje Stripe (potwierdź 0% marży)',
    given_title: 'Potwierdzono 0% marży',
    given:
      'Potwierdzone przez {{name}} dnia {{date}}: restauracje bez własnej stawki nie są obciążane prowizją za przetwarzanie, a Ty pokrywasz prowizje Stripe od ich płatności.',
    unknown_manager: 'były menedżer',
    withdraw: 'Wycofaj',
    withdraw_confirm: {
      title: 'Wycofać potwierdzenie marży 0%?',
      description:
        'Restauracje bez własnej stawki nie będą wtedy mogły ruszyć, a te już działające przestaną przyjmować płatności online, dopóki nie ustawisz stawki lub nie potwierdzisz ponownie.',
    },
  },
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  toasts: {
    load_error: 'Nie udało się wczytać Twoich opłat za przetwarzanie.',
    failed_to_save_changes: 'Nie udało się zapisać Twoich opłat za przetwarzanie.',
    changes_got_saved: 'Opłaty za przetwarzanie zapisane',
    consent_given: 'Potwierdzono 0% marży',
    consent_withdrawn: 'Potwierdzenie wycofane',
  },
};
